import { Empty, Spin } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/rootReducer';
import FolderStructure from '../../../../../common/FolderStructure/FolderStructure';
import { GrFormNext } from 'react-icons/gr';

type Props = {
    setSelectedType: (s?: string) => void;
};

const ReportingOrUpdates: React.FC<Props> = ({ setSelectedType }) => {
    const updates = useSelector((state: RootState) => state.investments.updates);
    const loading = useSelector((state: RootState) => state.investments.updatesLoading);

    return (
        <div className="px-6 pb-4">
            {!loading && (updates || []).length === 0 && (
                <nav className="py-1 pt-2 px-2 lg:px-4" aria-label="Breadcrumb" style={{ backgroundColor: '#F4F7FD' }}>
                    <li className="inline-flex items-center">
                        <span
                            className="inline-flex mr-1 items-center text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                            style={{ top: '-4px', color: '#404040' }}
                            onClick={() => setSelectedType(undefined)}
                        >
                            Documents
                        </span>
                        <span
                            className="inline-flex items-center text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                            style={{ top: '-4px', color: '#6E809D' }}
                        >
                            <GrFormNext className="mr-1 md:mr-1 relative" size="1.2rem" style={{ top: '1px' }} />
                        </span>
                    </li>
                    <li className="inline-flex items-center ml-1">
                        <span
                            className="inline-flex items-center text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                            style={{ top: '-4px', color: '#6E809D' }}
                        >
                            Updates
                        </span>
                    </li>
                </nav>
            )}
            {!loading && (updates || []).length > 0 && (
                <FolderStructure setInvestmentDoc={setSelectedType} dataFiles={updates || []} isDeal={false} />
            )}
            {loading && (
                <div className="flex justify-center items-center h-44">
                    <Spin />
                </div>
            )}
            {!loading && (updates || []).length === 0 && (
                <div className="pt-4">
                    <Empty />
                </div>
            )}
        </div>
    );
};

export default ReportingOrUpdates;
